import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Paper from '@mui/material/Paper';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Fab from '@mui/material/Fab';

import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import Group from '@mui/icons-material/Group';
import InfoIcon from '@mui/icons-material/Info';
import AttributionIcon from '@mui/icons-material/Attribution';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CancelIcon from '@mui/icons-material/Cancel';

import { UserGroup } from '../states/settingState';
import { AdditionUser, ROLE_NAME } from './Setting';

type Props = {
  open: boolean;
  users: AdditionUser[];
  userGroups: UserGroup[];
  role: string;
  handleUpdateUsersObject: (users: AdditionUser[]) => void;
  handleAddNewUser: () => void;
  handleClose: () => void;
  handleOk: () => void;
};

const MAIL_REGEX = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i;

export const UserAdditionDialog: React.FC<Props> = (props) => {

  const [subDialog, setSubDialog] = React.useState(false);
  const openSubDialog = Boolean(subDialog);
  const closeSubDialog = () => setSubDialog(false);
  const [subMessage, setSubMessage] = React.useState<string>('');

  const handleOrignOk = () => {
    if (props.users.find((u) => !u.commited)) {
      setSubMessage('編集中のユーザー情報を確定してください。');
      setSubDialog(true);
      return;
    } else if (props.users.length < 1) {
      setSubMessage('1件以上のユーザーを設定してください。');
      setSubDialog(true);
      return;
    }
    props.handleOk();
  };

  const getUserGroupName = (id) => {
    const t = props.userGroups.find((u) => u.userGroupId === id);
    return t ? t.groupName : '';
  }

  const handleCommit = (user: AdditionUser) => {
    // チェック
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((u) => !u.commited);
    if (target) {
      if (!target.name) {
        setSubMessage('ユーザー名を入力してください。');
        setSubDialog(true);
      } else if (!target.eMail) {
        setSubMessage('Eメールを入力してください。');
        setSubDialog(true);
      } else if (!MAIL_REGEX.test(target.eMail)) {
        setSubMessage('Eメールを正しく入力してください。');
        setSubDialog(true);
      } else if (!target.userGroupId) {
        setSubMessage('所属グループを指定してください。');
        setSubDialog(true);
      } else {
        target.commited = true;
        props.handleUpdateUsersObject(news);
      }
    }
  };
  const handleEdit = (user: AdditionUser) => {
    if (props.users.find((u) => !u.commited)) {
      // コミットされていないものがあれば編集できない
      setSubMessage('編集中のユーザー情報を確定してください。');
      setSubDialog(true);
      return;
    }
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((u) => u.id === user.id);
    if (target) {
      target.commited = false;
      props.handleUpdateUsersObject(news);
    }
  };

  const handleDelete = (user: AdditionUser) => {
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const newArray = news.filter(n => n.id !== user.id);
    props.handleUpdateUsersObject(newArray);
  };

  const handleAddUser = () => {
    if (props.users.find((u) => !u.commited)) {
      // コミットされていないものがあれば追加できない
      setSubMessage('編集中のユーザー情報を確定してください。');
      setSubDialog(true);
      return;
    }
    props.handleAddNewUser();
  };

  const createAction = (user: AdditionUser) => {
    if (user.commited) {
      if (props.users.find((u) => !u.commited)) {
        return '';
      }
      return (
        <>
          <Tooltip title="更新">
            <IconButton sx={{
              color: (theme) => theme.palette.secondary.main,
              margin: 1,
            }} edge="end" aria-label="enforcedate" onClick={() => handleEdit(user)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="削除">
            <IconButton sx={{
              color: (theme) => theme.palette.secondary.main,
              margin: 1,
            }} edge="end" aria-label="edit" onClick={() => handleDelete(user)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </>
      );
    }
    return (
      <>
        <Tooltip title="確定">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="enforcedate" onClick={() => handleCommit(user)}>
            <CheckRoundedIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="キャンセル">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleDelete(user)}>
            <CancelIcon />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    const newValue = value.replace(/[\s]/g, '');
    const newnewValue = newValue ? newValue : '';
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((n) => !n.commited);
    if (target) {
      target.name = newnewValue;
      props.handleUpdateUsersObject(news);
    }
  };
  const handleChangeEMail = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    const newValue = value.replace(/[\s]/g, '');
    const newnewValue = newValue ? newValue : '';
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((n) => !n.commited);
    if (target) {
      target.eMail = newnewValue;
      props.handleUpdateUsersObject(news);
    }
  };
  const handleChangeRole = (event) => {
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((n) => !n.commited);
    if (target) {
      target.role = event.target.value;
      props.handleUpdateUsersObject(news);
    }
  };
  const handleChangeUserGroup = (event) => {
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((n) => !n.commited);
    if (target) {
      target.userGroupId = event.target.value;
      target.userGroupName = getUserGroupName(target.userGroupId);
      props.handleUpdateUsersObject(news);
    }
  };
  const handleChangeEnabled = (event) => {
    const news: AdditionUser[] = JSON.parse(JSON.stringify(props.users));
    const target = news.find((n) => !n.commited);
    if (target) {
      target.notificationFlg = event.target.checked;
      props.handleUpdateUsersObject(news);
    }
  };

  const createUserGroups = () => {
    return props.userGroups.map((g, i) => {
      return (<MenuItem key={'' + i} value={g.userGroupId} >{g.groupName}</MenuItem>);
    });
  };

  const getRoles = () => {
    const roles: React.JSX.Element[] = [];
    if (props.role === 'Manager') {
      roles.push((<MenuItem key={'0'} value={'Manager'} >{'管理者'}</MenuItem>));
    }
    roles.push((<MenuItem key={'1'} value={'Approver'} >{'承認者'}</MenuItem>));
    roles.push((<MenuItem key={'2'} value={'Editor'} >{'編集者'}</MenuItem>));
    roles.push((<MenuItem key={'3'} value={'Viewer'} >{'閲覧者'}</MenuItem>));

    return roles;
  };

  const createContents = () => {
    const contents = props.users.map((u, index) => {
      if (u.commited) {
        return (
          <div key={`result-${index}`}>
            <ListItem sx={{
              backgroundColor: (theme) => u.commited ? theme.palette.primary[50] : theme.palette.secondary[50],
            }} secondaryAction={
              <>
                {createAction(u)}
              </>
            }>
              <ListItemIcon sx={{
                color: (theme) => theme.palette.primary.main,
                margin: 1,
              }}>
                <AccountCircle />
              </ListItemIcon>
              <ListItemText primary={
                <>
                  <Typography variant="body1" component="span" sx={{
                    display: 'inline-block',
                    width: '70%',
                    verticalAlign: 'middle'
                  }}>
                    {u.name}
                  </Typography>
                </>
              } secondary={
                <>
                  <Tooltip title="Eメール">
                    <MailIcon color='primary' sx={{
                      position: 'relative',
                      top: 5,
                      left: 5,
                      marginRight: 2,
                    }} />
                  </Tooltip>
                  <Typography variant="body1" component="span">{u.eMail}</Typography>
                  <br />
                  <Tooltip title="ユーザー権限">
                    <Group color='primary' sx={{
                      position: 'relative',
                      top: 5,
                      left: 5,
                      marginRight: 2,
                    }} />
                  </Tooltip>
                  <Typography variant="body1" component="span">{ROLE_NAME[u.role]}</Typography>
                  <br />
                  <Tooltip title="所属グループ">
                    <AttributionIcon color='primary' sx={{
                      position: 'relative',
                      top: 5,
                      left: 5,
                      marginRight: 2,
                    }} />
                  </Tooltip>
                  <Typography variant="body1" component="span">{u.userGroupName}</Typography>
                  <br />
                  <Tooltip title="ユーザーへの検証コード送信">
                    <InfoIcon color='primary' sx={{
                      position: 'relative',
                      top: 5,
                      left: 5,
                      marginRight: 2,
                    }} />
                  </Tooltip>
                  <Typography variant="body1" component="span">{u.notificationFlg ? 'ユーザーへ検証コード送信を行います。' : 'ユーザーへ検証コード送信を行いません。'}</Typography>
                </>
              } />
            </ListItem>
            <Divider />
          </div>
        );
      }
      return (
        <div key={`result-${index}`}>
          <ListItem sx={{
            backgroundColor: (theme) => u.commited ? theme.palette.primary[50] : theme.palette.secondary[50],
          }} secondaryAction={
            <>
              {createAction(u)}
            </>
          }>
            <ListItemIcon sx={{
              color: (theme) => theme.palette.primary.main,
              margin: 1,
            }}>
              <AccountCircle />
            </ListItemIcon>
            <Grid container spacing={0}>
              <Grid size={12}>
                <TextField
                  id={'name'}
                  label={'ユーザー名'}
                  value={u.name}
                  sx={{
                    width: '70%',
                  }}
                  onChange={handleChangeName}
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  id={'email'}
                  label={'Eメール'}
                  value={u.eMail}
                  sx={{
                    width: '70%',
                  }}
                  onChange={handleChangeEMail}
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid size={12}>
                <FormControl sx={{ m: 1, minWidth: 200 }}>
                  <InputLabel id="type-select-readonly-label">ユーザー権限</InputLabel>
                  <Select
                    labelId="type-select-helper-label"
                    id="type-select-helper"
                    label="ユーザー権限"
                    value={u.role}
                    onChange={handleChangeRole}
                  >
                    {getRoles()}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControl sx={{ m: 1, minWidth: 200 }}>
                  <InputLabel id="type-select-readonly-label">所属グループ</InputLabel>
                  <Select
                    labelId="type-select-helper-label"
                    id="type-select-helper"
                    label="所属グループ"
                    value={u.userGroupId}
                    onChange={handleChangeUserGroup}
                  >
                    {createUserGroups()}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={u.notificationFlg}
                      onChange={handleChangeEnabled}
                      name="isUnlimited"
                      color="primary"
                    />
                  }
                  label={u.notificationFlg ? 'ユーザーへの検証コードの送信を行います。' : 'ユーザーへ検証コードの送信を行いません。'}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider />
        </div>
      );
    });

    return (
      <List component="nav" aria-label="My editing acts">
        {contents}
      </List>
    );
  };

  const createAddButton = () => {
    if (props.users.find((n) => !n.commited)) {
      return '';
    }
    return (
      <Tooltip title="追加">
        <Fab size="small" color="secondary" aria-label="list" sx={{
          margin: 1,
        }} onClick={handleAddUser}>
          <AddRoundedIcon />
        </Fab>
      </Tooltip>
    );
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '90%' } }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"ユーザーの追加"}</DialogTitle>
      <DialogContent sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
          margin: (theme) => theme.spacing(1),
        },
      }}>
        <Paper sx={{
          width: '100%',
          margin: (theme) => theme.spacing(1),
          padding: (theme) => theme.spacing(3),
          backgroundColor: (theme) => theme.palette.primary[50],
        }} elevation={3}>
          {createContents()}
          {createAddButton()}
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOrignOk} color="primary">
          確定
        </Button>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
      <Dialog
        open={openSubDialog}
        keepMounted
        onClose={closeSubDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">エラー</DialogTitle>
        <DialogContent>
          <Typography>{subMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSubDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};    